import * as React from "react";

import { useRevertEmailChangeMutation } from "@/api/email-change";
import { EmailChangeActionView } from "@/views/auth/email-change/EmailChangeActionView";

export const RevertEmailChangeView = () => {
  const [revertEmailChange] = useRevertEmailChangeMutation();
  const submit = React.useCallback(
    (payload: { token: string }) => revertEmailChange(payload).unwrap(),
    [revertEmailChange],
  );

  return <EmailChangeActionView action="revert" submit={submit} />;
};
